module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"language":"Язык","save":"Сохранить","settingsChanged":"Настройки сохранены"}}')
  delete Component.options._Ctor
}
